var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M2.15619 4.27788C2.13956 4.1297 2.25551 4 2.40463 4H13.5933C13.7432 4 13.8593 4.1309 13.8416 4.27968L12.5263 15.2797C12.5113 15.4054 12.4047 15.5 12.2781 15.5H3.63921C3.51193 15.5 3.40496 15.4044 3.39077 15.2779L2.15619 4.27788Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 1.73438,
    y: 2.25,
    width: 12.5312,
    height: 1.40625,
    rx: 0.25,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 6.09375,
    y: 0.5,
    width: 3.8125,
    height: 1.40625,
    rx: 0.25,
    fill: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.971388235ed8efe3481951139da05223.svg";
export { ForwardRef as ReactComponent };